import { render, staticRenderFns } from "./GatheringStats.vue?vue&type=template&id=b1ed1da0&"
import script from "./GatheringStats.vue?vue&type=script&lang=js&"
export * from "./GatheringStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GatheringStats.vue"
export default component.exports